import React from "react";
import { IconButton } from "@mui/material";
import ExpandIcon from "../../assets/Icon/ExpandIcon.png";

const PdfDetails = () => {
  return (
    <IconButton sx={{ padding: "0px" }}>
      <img src={ExpandIcon} alt="icon" />
    </IconButton>
  );
};

export default PdfDetails;
